div
<template>
	<div :class="modalIsOpen ? 'side-over--active' : ''">
		<div
			class="
				fixed
				h-screen
				w-screen
				top-0
				left-0
				bg-black
				opacity-20
				z-30
			"
			v-if="modalIsOpen"
			@click="modalIsOpen = false"
		></div>
		<CreateGoalModal
			:show="modalIsOpen"
			v-model:skills="skills"
			v-model:data="goalPayloadData"
			v-model:error="error"
			v-model:tab-active="tabActive"
			@submit="() => {}"
			@close="closeModal"
			@updated="updated"
		/>
	</div>
	<div class="flex w-full">
		<div
			class="flex-1 create-content body-content"
			:class="{ 'body-content--active': isSlideOpen }"
		>
			<div
				class="__goal-management-student-detail p-10 pb-8 md-down:px-4"
			>
				<div class="flex items-center justify-between">
					<div
						class="
							__record__title
							text-neutral-500
							font-bold
							whitespace-nowrap
							flex flex-nowrap
							items-center
							text-4xl
							gap-4
						"
					>
						<svg
							class="cursor-pointer"
							width="28"
							height="28"
							viewBox="0 0 28 28"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
							@click="$router.back()"
						>
							<path
								d="M17.5 7L10.5 14L17.5 21"
								stroke="#94A3B8"
								stroke-width="2"
								stroke-linecap="round"
								stroke-linejoin="round"
							/>
						</svg>
						<div>Tạo biểu mẫu</div>
					</div>
					<div
						class="
							text-sm text-neutral-500
							font-semibold
							flex
							items-center
							justify-end
						"
					>
						<button
							class="
								button-p
								text-center
								w-fit
								btn--text
								text-neutral-500
								hover:text-neutral-600
							"
							type="button"
							@click="$router.push(`/form-evaluation`)"
						>
							<svg
								class="mr-2 text-neutral-400"
								fill="none"
								height="16"
								viewBox="0 0 16 16"
								width="16"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M1.5 7.99996L0.719131 7.37526L0.219375 7.99996L0.719131 8.62465L1.5 7.99996ZM7.5 8.99996C8.05228 8.99996 8.5 8.55224 8.5 7.99996C8.5 7.44767 8.05228 6.99996 7.5 6.99996V8.99996ZM3.3858 4.04193L0.719131 7.37526L2.28087 8.62465L4.94754 5.29132L3.3858 4.04193ZM0.719131 8.62465L3.3858 11.958L4.94754 10.7086L2.28087 7.37526L0.719131 8.62465ZM1.5 8.99996H7.5V6.99996H1.5V8.99996Z"
									fill="currentColor"
								/>
								<path
									d="M7.78738 13.3439L8.31032 12.4915L7.78738 13.3439ZM6.97976 12.3905L6.05301 12.7662L6.97976 12.3905ZM14.499 12.5015L15.3875 12.9603L14.499 12.5015ZM12.7525 13.981L12.4461 13.0291L12.7525 13.981ZM14.499 3.49854L15.3875 3.0398L14.499 3.49854ZM13.8333 6.81921V9.18087H15.8333V6.81921H13.8333ZM7.83325 5.42133V5.29122H5.83325V5.42133H7.83325ZM9.58524 12.7782C8.62733 12.6186 8.43551 12.5683 8.31032 12.4915L7.26445 14.1962C7.80406 14.5273 8.47961 14.6216 9.25644 14.751L9.58524 12.7782ZM5.83325 10.7107C5.83325 11.4979 5.81518 12.1795 6.05301 12.7662L7.90651 12.0148C7.85132 11.8787 7.83325 11.6814 7.83325 10.7107H5.83325ZM8.31032 12.4915C8.12826 12.3798 7.98675 12.2128 7.90651 12.0148L6.05301 12.7662C6.29374 13.36 6.71828 13.8612 7.26445 14.1962L8.31032 12.4915ZM13.8333 9.18087C13.8333 10.0882 13.8325 10.7099 13.7946 11.1876C13.7573 11.6573 13.6894 11.8898 13.6104 12.0428L15.3875 12.9603C15.6428 12.4658 15.742 11.929 15.7883 11.3458C15.834 10.7705 15.8333 10.0557 15.8333 9.18087H13.8333ZM9.25644 14.751C10.1198 14.8949 10.8251 15.0132 11.4002 15.0628C11.9832 15.113 12.5291 15.1035 13.0589 14.9329L12.4461 13.0291C12.2822 13.0819 12.0416 13.1107 11.5719 13.0702C11.0943 13.029 10.4806 12.9275 9.58524 12.7782L9.25644 14.751ZM13.6104 12.0428C13.3679 12.5125 12.9493 12.8671 12.4461 13.0291L13.0589 14.9329C14.0653 14.609 14.9025 13.8997 15.3875 12.9603L13.6104 12.0428ZM9.58645 3.22163C10.4814 3.07248 11.0948 2.97099 11.5722 2.92986C12.0416 2.88942 12.2822 2.91819 12.4461 2.97096L13.0589 1.06717C12.5292 0.896646 11.9834 0.887021 11.4005 0.937243C10.8256 0.986778 10.1206 1.10503 9.25766 1.24885L9.58645 3.22163ZM15.8333 6.81921C15.8333 5.9444 15.834 5.22954 15.7883 4.65428C15.742 4.07104 15.6428 3.53429 15.3875 3.0398L13.6104 3.95728C13.6894 4.1103 13.7573 4.34283 13.7946 4.81252C13.8325 5.29019 13.8333 5.91191 13.8333 6.81921H15.8333ZM12.4461 2.97096C12.9493 3.13294 13.3679 3.48755 13.6104 3.95728L15.3875 3.0398C14.9025 2.10035 14.0653 1.39113 13.0589 1.06717L12.4461 2.97096ZM9.25766 1.24885C8.83685 1.31898 8.47124 1.37935 8.17099 1.45102C7.85987 1.52528 7.55473 1.62545 7.26252 1.80503L8.30967 3.50898C8.35038 3.48397 8.42887 3.44565 8.63532 3.39637C8.85265 3.3445 9.13857 3.29628 9.58645 3.22163L9.25766 1.24885ZM7.83325 5.29122C7.83325 4.83715 7.83381 4.5472 7.84925 4.3243C7.86391 4.11256 7.88881 4.02884 7.90679 3.98457L6.05387 3.23179C5.92477 3.54955 5.87613 3.86701 5.85403 4.1861C5.8327 4.49405 5.83325 4.86461 5.83325 5.29122H7.83325ZM7.26252 1.80503C6.71792 2.13971 6.29446 2.63958 6.05387 3.23179L7.90679 3.98457C7.98699 3.78717 8.12814 3.62054 8.30967 3.50898L7.26252 1.80503Z"
									fill="currentColor"
								/>
							</svg>
							Thoát
						</button>
					</div>
				</div>
				<div class="flex justify-end mt-2">
					<button
						type="button"
						class="button-p text-center btn--ghost w-max"
						@click="isSlideOpen = true"
					>
						Xem trước
					</button>
				</div>
			</div>
			<div
				class="
					__goal-management-student-detail__overview
					px-10
					pb-10
					md-down:px-4
				"
			>
				<div class="w-full">
					<div class="mb-10" v-if="alertShow">
						<div
							class="
								bg-yellow-50
								border-l-4 border-yellow-600
								p-4
								rounded-md
							"
						>
							<div class="relative">
								<div class="flex items-center gap-2">
									<img
										src="@/assets/images/logo/logo.svg"
										alt="luca-logo"
										height="24"
										width="35"
									/>
									<div class="text-neutral-600 text-sm">
										Bạn hãy thêm mục tiêu từ Thư viện mục
										tiêu vào Biểu mẫu đánh giá
									</div>
								</div>
								<div
									class="
										top-1
										right-2
										absolute
										cursor-pointer
									"
									@click="alertShow = false"
								>
									<svg
										width="12"
										height="12"
										viewBox="0 0 12 12"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											fill-rule="evenodd"
											clip-rule="evenodd"
											d="M0.292893 0.292893C0.683417 -0.0976311 1.31658 -0.0976311 1.70711 0.292893L6 4.58579L10.2929 0.292893C10.6834 -0.0976311 11.3166 -0.0976311 11.7071 0.292893C12.0976 0.683417 12.0976 1.31658 11.7071 1.70711L7.41421 6L11.7071 10.2929C12.0976 10.6834 12.0976 11.3166 11.7071 11.7071C11.3166 12.0976 10.6834 12.0976 10.2929 11.7071L6 7.41421L1.70711 11.7071C1.31658 12.0976 0.683417 12.0976 0.292893 11.7071C-0.0976311 11.3166 -0.0976311 10.6834 0.292893 10.2929L4.58579 6L0.292893 1.70711C-0.0976311 1.31658 -0.0976311 0.683417 0.292893 0.292893Z"
											fill="#E5A42B"
										/>
									</svg>
								</div>
							</div>
						</div>
					</div>
					<div class="w-full">
						<div>
							<div>
								<div class="__report-lesson pb-30">
									<div
										class="
											__breadcrumbs
											text-sm text-neutral-500
											font-semibold
											flex-nowrap flex
											items-center
											justify-between
										"
									>
										<div class="flex items-center">
											<router-link
												:to="{
													name: 'create_form_by_lib',
												}"
											>
												Thư Viện Nội Bộ
											</router-link>
											<div
												class="__breadcrumbs__decorate"
											>
												<DaIcon
													name="das--chevron-down"
													class="
														transform
														-rotate-90
														h-3
														w-3
														mx-2
													"
												/>
											</div>
											<div>{{ goal.name }}</div>
										</div>
									</div>
									<div
										class="
											mt-6
											__report-lesson__header
											flex flex-nowrap
											justify-between
											items-center
											w-full
											gap-4
										"
									>
										<div
											class="
												__record__title
												text-neutral-500
												font-semibold
												whitespace-wrap
												flex flex-nowrap
												items-start
												text-4xl
												gap-4
												justify-between
												w-full
											"
										>
											<div>
												<div
													class="
														flex
														items-center
														gap-6
													"
												>
													<svg
														width="28"
														height="28"
														viewBox="0 0 28 28"
														fill="none"
														xmlns="http://www.w3.org/2000/svg"
														class="mb-1"
													>
														<path
															d="M25.4998 5.98259H11.021C10.7609 5.98259 10.5219 5.8514 10.3931 5.63913L9.104 3.51831C8.65802 2.78525 7.83103 2.33337 6.93503 2.33337H2.5C1.11897 2.33337 0 3.38904 0 4.69193V22.1415C0 23.4444 1.11897 24.5 2.5 24.5H25.5C26.881 24.5 28 23.4444 28 22.1415V8.34109C28 7.03906 26.881 5.98253 25.5 5.98253L25.4998 5.98259ZM4.09697 16.1387H6.65903C7.15613 16.1387 7.55903 16.5188 7.55903 16.9878C7.55903 17.4567 7.15613 17.8368 6.65903 17.8368H4.09697C3.59987 17.8368 3.19697 17.4567 3.19697 16.9878C3.19697 16.5188 3.59987 16.1387 4.09697 16.1387ZM10.437 21.1483H4.09697C3.59987 21.1483 3.19697 20.7682 3.19697 20.2992C3.19697 19.8303 3.59987 19.4501 4.09697 19.4501H10.4381C10.9352 19.4501 11.3381 19.8303 11.3381 20.2992C11.3379 20.768 10.935 21.1483 10.437 21.1483Z"
															fill="#94A3B8"
														/>
													</svg>
													<span>{{ goal.name }}</span>
												</div>
											</div>
										</div>
										<button
											class="
												delete-button
												flex
												items-center
												whitespace-nowrap
											"
											:class="{
												'disable-button':
													goalsSelected.length == 0,
											}"
											@click="addMultiGoal"
										>
											Thêm mục tiêu đã chọn
										</button>
									</div>
									<div class="mt-2">
										<div v-if="!isDataLoading">
											<div v-if="folders.length">
												<div
													v-for="folder in folders"
													:key="folder.id"
												>
													<GoalFolderItem
														:is-edit="false"
														:data="folder"
														:skills="skills"
														:selected-goal="
															selected
														"
														@action-clicked="doGoal"
														:isInCreateGoal="true"
														:formCreate="true"
													>
														<template
															v-slot:actions
														>
															<div></div>
														</template>
													</GoalFolderItem>
												</div>
											</div>
											<div
												v-else
												class="
													w-full
													h-full
													flex
													items-center
													justify-center
													flex-col
												"
											>
												<img
													src="@/assets/images/illustrations/not_found.png"
													alt=""
													height="250"
													width="250"
												/>
												<div
													class="
														text-neutral-400
														text-lg
														text-center
													"
													style="max-width: 900px"
												>
													Chưa có thư mục hay mục tiêu
													nào trong thư viện này.
													<br /><br />
													Nếu ngân hàng của bạn gồm
													nhiều mục tiêu được chia
													theo lĩnh vực hoặc chia theo
													độ tuổi hoặc theo vấn đề của
													trẻ thì bạn nên tạo Thư mục
													trước khi tạo Mục tiêu.
												</div>
											</div>
										</div>
										<div
											v-else
											class="fixed top-1/2 left-1/2"
										>
											<Loading />
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div
			class="h-screen create-content slide-content"
			:class="{ 'slide-content--active': isSlideOpen }"
		>
			<div
				class="h-screen fixed top-0 right-0 overflow-y-auto"
				style="width: inherit; background: #faf5f1"
			>
				<goal-form-evaluation
					@close="isSlideOpen = false"
					:reload="reload"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import DaIcon from '@/components/elements/daIcon/DaIcon';
import GoalFolderItem from '@/views/goalFolders/features/GoalFolderItem';
import Loading from '@/components/common/Loading';
import { $api } from '@/services';
import CreateGoalModal from '@/views/createGoalByLib/CreateGoalModal';
import GoalFormEvaluation from './GoalFormEvaluation.vue';

export default {
	name: 'CreateGoalByLibGoals',
	components: {
		CreateGoalModal,
		Loading,
		GoalFolderItem,
		DaIcon,
		GoalFormEvaluation,
	},
	data() {
		return {
			alertShow: true,
			isLoading: true,
			goal: {
				id: '',
				name: '',
				created_by_staff: {
					name: '',
				},
				last_updated_at: null,
			},
			inProgress: false,
			skills: [],
			isDataLoading: true,
			modalIsOpen: false,
			goalPayloadData: null,
			error: '',
			tabActive: 0,
			folders: [],
			selected: [],
			isSlideOpen: false,
			reload: 0,
		};
	},

	created() {
		this.$store.dispatch('clearSelected');
		this.fetchGoalLib();
		this.fetchSkill();
		this.fetchGoalFolders();
		this.isSlideOpen = window.screen.width >= 1024;
		window.scrollTo(0, 0);
	},

	computed: {
		goalId() {
			return this.$route?.params?.libId || '';
		},

		isAdmin() {
			return this.$store.getters.isAdmin;
		},

		formId() {
			return this.$route?.params?.id || '';
		},

		goalsSelected() {
			const s = this.$store.getters.goalsSelected;
			return (s || []).map((i) => i.id);
		},
	},

	methods: {
		updated() {
			this.selected.push(this.goalPayloadData?.id);
			// this.fetchGoalFolders();
			this.$emit('updated');
			this.closeModal();
		},

		async addMultiGoal() {
			try {
				await $api.form.addGoalToForm(this.formId, {
					to_assessment_form_id: this.formId,
					library_item_ids: this.goalsSelected,
				});
				this.$store.dispatch('setAlertMessage', {
					message: 'Đã thêm mục tiêu thành công',
				});
				for (let i of this.goalsSelected) {
					this.$store.dispatch('taughtGoal', i);
				}
				this.reload++;
			} catch (e) {
				this.$store.dispatch('setAlertMessage', {
					message:
						e?.response?.data?.errors?.join('<br/>') ||
						'Đã có lỗi xảy ra. Vui lòng thử lại',
					type: 'danger',
				});
			}
		},
		async fetchSkill() {
			try {
				const {
					data: { data },
				} = await $api.goal.allSkills(this.isAdmin);
				if (data) {
					this.skills = data;
				}
			} catch (e) {
				console.log(e);
			}
		},

		async fetchGoalFolders() {
			try {
				const {
					data: { data },
				} = await $api.goal.fetchAllGoalFolders(
					this.goalId,
					{},
					this.isAdmin, true
				);
				this.folders = data;
			} catch (e) {
				this.$store.dispatch('setAlertMessage', {
					message:
						e?.response?.data?.errors?.join('<br/>') ||
						'Đã có lỗi xảy ra. Vui lòng thử lại',
					type: 'danger',
				});
			} finally {
				this.isDataLoading = false;
			}
		},

		async fetchGoalLib() {
			try {
				const {
					data: { data },
				} = await $api.goal.fetchGoalLibDetail(
					this.goalId,
					this.isAdmin
				);
				this.goal = data;
			} catch (e) {
				this.$store.dispatch('setAlertMessage', {
					message:
						e?.response?.data?.errors?.join('<br/>') ||
						'Đã có lỗi xảy ra. Vui lòng thử lại',
					type: 'danger',
				});
			}
		},

		async doGoal(goal) {
			try {
				const res = await $api.form.addGoalToForm(this.formId, {
					to_assessment_form_id: this.formId,
					library_item_ids: [goal.id],
				});
				if (res) {
					this.$store.dispatch('setAlertMessage', {
						message: 'Đã thêm mục tiêu thành công',
						type: 'success',
					});
					this.$store.dispatch('taughtGoal', goal.id);
					this.reload++;
				}
			} catch (e) {
				this.$store.dispatch('setAlertMessage', {
					message:
						e?.response?.data?.errors?.join('<br/>') ||
						'Đã có lỗi xảy ra. Vui lòng thử lại',
					type: 'danger',
				});
			}
		},

		closeModal() {
			this.modalIsOpen = false;
			this.goalPayloadData = null;
			this.error = '';
			this.tabActive = 0;
		},
	},
};
</script>
<style scoped lang="scss">
@import '../../assets/styles/_responsive';
.delete-button {
	padding: 12px 20px;
	gap: 6px;
	border-radius: 4px;
	border: 1px solid #d89210;
	font-size: 14px;
	font-weight: 600;
	line-height: 20px;
	color: #d89210;
}
.disable-button {
	background: #e1e7ef !important;
	border: 1px solid #cbd5e1 !important;
	color: #cbd5e1;
}
.create-content {
	transition: all 0.5s ease;
}

.body-content {
	transition: all 0.5s ease;
	min-width: 100vw;

	@include media-breakpoint-up(md) {
		min-width: auto;
	}

	&--active {
		@include media-breakpoint-up(md) {
			width: 50vw;
		}
	}
}

.slide-content {
	width: 0;

	&--active {
		width: 50vw;
	}

	@include media-breakpoint-down(md) {
		&--active {
			position: fixed;
			width: 100vw !important;
		}
	}
}
</style>
